import axios from "axios";


export const Biotin = ()=>{
  return axios({
    method: "get",
    baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
  });
}


export const Breakfast = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });

}


export const FreaturedBrands = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
    
}


export const Homeopathy = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
    
}


export const PersonalCare = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
    
}


export const PopularCategory = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
    
}



export const PopularCombo = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
}



export const TrendingNow = ()=>{
    return axios({
        method: "get",
        baseURL: "https://bloodmedplus-server.onrender.com/Landing_page",
      });
}